import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css'; // Bootstrap CSS
import * as bootstrap from 'bootstrap'; // Import Bootstrap JS as a module
import 'bootstrap-icons/font/bootstrap-icons.css'; // Bootstrap Icons

// Explicitly attach bootstrap to window
window.bootstrap = bootstrap;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

reportWebVitals();